import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {NewsQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const NEWS = gql`
    query news($page: Int, $limit: Int, $publishDate: String) {
        news(page: $page, limit: $limit, publish_date: $publishDate, type: "app") {
            id
            user {
                id
                name
                token
            }
            title
            seo_url
            small_description
            preface
            thumbnail
            image
            content
            publish_app
            publish_date
            created_at
            created_at_iso8601
        }
        newsPageInfo(type: "app") {
            count
            __typename
        }
    }
`;

export class News {
    static async getNews(page: number, limit: number, publishDate: string) {
        return await pwaClient.query<NewsQuery>({
            query: NEWS,
            variables: {
                page,
                limit,
                publishDate,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
